import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';

type Props = {
    active: boolean;
    className?: string;
    onClick: Function;
};

const Report = (props: Props) => {
    const { active, className, onClick } = props;
    const id = active ? 'review.reported' : 'review.report';
    return (
        <Link className={className} onClick={onClick}>
            <FormattedMessage id={id} />
        </Link>
    );
};

export default React.memo<Props>(Report, isEqual);
